import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper";
import { FeaturedDoctorsViewModel } from "./FeaturedDoctorsViewModel.csharp";
import { FeaturedDoctorCard } from "./FeaturedDoctorCard";

export const FeaturedDoctors: React.FC<FeaturedDoctorsViewModel> = ({
  heading,
  doctors,
  moreDoctorsUrl,
  itemForegroundColor,
}) => {
  const breakpoints = {
    0: {
      slidesPerView: 1.2,
    },
    575: {
      slidesPerView: 2.2,
    },
    951: {
      slidesPerView: 4,
    },
  };

  return (
    <section>
      <div className="body-text-container">
        <h2 className="h3 mb-2 mb-md-3">{heading}</h2>
      </div>
      <div className="mb-5">
        <Swiper
          breakpoints={breakpoints}
          spaceBetween={20}
          modules={[FreeMode]}
          freeMode={{ enabled: true, momentum: true }}
        >
          {doctors.map((d) => (
            <SwiperSlide key={d.name} className="featuredDoctorSlide">
              <FeaturedDoctorCard
                doctor={d}
                backgroundColor={itemForegroundColor}
              />
            </SwiperSlide>
          ))}
        </Swiper>

        {moreDoctorsUrl && (
          <div className="row mt-1">
            <p className="read-more">
              <a href={moreDoctorsUrl}>Se alle behandlere</a>
            </p>
          </div>
        )}
      </div>
    </section>
  );
};
